import { getMemberDisplayName } from '@/collaboration/utils/members'
import type { MatterMemberRead } from '@/matter/components/manage-members/schemas'

/** Owner label shown on the current user's own conversations. */
export const kOwnConversationLabel = 'Me'

/** user_id to display name lookup for a matter's members. */
export function buildMemberNamesById(members: MatterMemberRead[]): Map<string, string> {
  return new Map(members.map((member) => [member.user_id, getMemberDisplayName(member)]))
}

/**
 * Owner label for a conversation card's metadata row. Purely a display concern: only surfaced when
 * ownership display is enabled (a shared matter with the collaborator-chats feature on); otherwise
 * nothing is shown. Read-only/view-only state is a separate permission concern — derive it from
 * `useIsConversationOwner`, not from this label.
 */
export function getConversationOwnerLabel({
  conversationUserId,
  currentUserId,
  memberNamesById,
  enabled,
}: {
  conversationUserId: string
  currentUserId: string | undefined
  memberNamesById: Map<string, string>
  enabled: boolean
}): string | undefined {
  if (!enabled || !currentUserId) return undefined
  if (conversationUserId === currentUserId) return kOwnConversationLabel
  // undefined until members load (or if the owner was removed from the matter); the View Only tag still shows.
  return memberNamesById.get(conversationUserId)
}
